import FormSelect from '@componentsroot/Form/FormSelect';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import tokens from '@verifime/design-tokens';
import { EntityStatus, IDENTITY_TYPES_MAP, IdentityTypeCode } from '@verifime/utils';
import { useForm } from 'react-hook-form';
import { FilterPanelProps } from './types';
import { IdentityFilter } from '../../types';

export interface IdentityFilterPanelProps extends FilterPanelProps<IdentityFilter> {}

export default function IdentityFilterPanel({
  defaultValues,
  onApply,
  onCancel,
}: IdentityFilterPanelProps) {
  const { control, handleSubmit } = useForm<IdentityFilter>({
    defaultValues,
  });

  const handleOnApply = handleSubmit((data) => onApply(data));

  // Get all identity type codes as an array
  const identityTypeCodes = Object.keys(IdentityTypeCode) as IdentityTypeCode[];

  // Get all entity status values as an array
  const entityStatusValues = Object.values(EntityStatus).filter((s) => s !== EntityStatus.Empty);

  return (
    <Stack
      component="form"
      spacing={tokens.spacingBase}
      sx={{ padding: tokens.spacingBase }}
      data-component="identity-filter-panel"
    >
      <FormSelect
        name="type"
        label="Identity Type"
        control={control as any}
        defaultValue={defaultValues.type}
      >
        {identityTypeCodes.map((typeCode) => (
          <MenuItem key={typeCode} value={typeCode}>
            {IDENTITY_TYPES_MAP[typeCode]?.label || typeCode}
          </MenuItem>
        ))}
      </FormSelect>

      <FormSelect
        name="status"
        label="Status"
        control={control as any}
        defaultValue={defaultValues.status}
      >
        {entityStatusValues.map((status) => (
          <MenuItem key={status} value={status}>
            {status}
          </MenuItem>
        ))}
      </FormSelect>

      <Stack direction="row" spacing={tokens.spacing2xs} justifyContent="flex-end">
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleOnApply}>
          Apply
        </Button>
      </Stack>
    </Stack>
  );
}
